<template>
  <div class="category flex justify-center">
    <transition name="fadeLoader">
      <PageLoader v-if="!subscriptions" ref="loadingOverlay" />
    </transition>
    <div v-if="subscriptions" class="container py-16">
      <h1 class="text-secondary text-center text-3xl font-bold mb-16">
        {{ $t("subscriptionpage.title_white") }}
        <span class="text-accent">{{ $t("subscriptionpage.title_red") }}</span>
      </h1>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div
          v-for="subscription in subscriptions"
          :key="subscription.id"
          class="
            p-8
            rounded-xl
            border border-primary-variation
            shadow-md
            relative
          "
          :class="[subscription.featured ? 'bg-accent-variation' : 'bg-black']"
        >
          <div
            class="font-semibold text-lg"
            :class="[
              subscription.featured
                ? 'text-secondary'
                : 'text-secondary-variation',
            ]"
          >
            {{ subscription.name }}
          </div>
          <div
            class="font-bold text-4xl mt-8 mb-6"
            :class="[
              subscription.featured
                ? 'text-secondary'
                : 'text-accent-variation',
            ]"
          >
            ${{ subscription.price }}
            <span class="text-secondary font-semibold text-base">{{
              $t("subscriptionpage.for_days", { days: subscription.days })
            }}</span>
          </div>
          <div
            class="divider border-t opacity-50 mb-8"
            :class="[
              subscription.featured
                ? 'border-secondary'
                : 'border-secondary-variation',
            ]"
          ></div>
          <div
            class="feature-list mb-8"
            :class="[
              subscription.featured
                ? 'text-secondary'
                : 'text-secondary-variation',
            ]"
          >
            <div
              v-for="feature in features"
              :key="feature"
              class="flex items-center text-lg mt-1.5"
            >
              <CheckIcon
                class="w-8 h-8 mr-2"
                :class="[
                  subscription.featured
                    ? 'text-secondary'
                    : ' text-accent-variation',
                ]"
              />
              {{ feature }}
            </div>
          </div>
          <div class="flex items-center justify-center">
            <MediumButton
              @click="openPaymentModal(subscription.id)"
              class="bg-secondary text-black hover:text-secondary"
              :class="[
                subscription.featured
                  ? 'hover:bg-black'
                  : 'hover:bg-accent-variation',
              ]"
              ><CartIcon class="w-6 h-6 mr-2" />{{
                $t("subscriptionpage.subscribe_now")
              }}</MediumButton
            >
          </div>
        </div>
      </div>
    </div>
    <PaymentModal
      type="subscription"
      :isModalOpen="openModal"
      :item="subscription"
      @modalClose="closePaymentModal"
    />
  </div>
</template>

<script>
import MediumButton from "@/components/UI/Buttons/MediumButton.vue";
import PageLoader from "@/components/UI/Loader/PageLoader";
import CartIcon from "@/components/icons/CartIcon";
import CheckIcon from "@/components/icons/CheckIcon";
import PaymentModal from "@/components/UI/Modal/PaymentModal.vue";
import axios from "axios";
export default {
  name: "SubscriptionListView",
  components: {
    MediumButton,
    PageLoader,
    CartIcon,
    CheckIcon,
    PaymentModal,
  },
  data() {
    return {
      subscriptions: null,
      subscription: null,
      openModal: false,
    };
  },
  computed: {
    features() {
      return [
        this.$t("subscriptionpage.feature_1"),
        this.$t("subscriptionpage.feature_2"),
        this.$t("subscriptionpage.feature_3"),
        this.$t("subscriptionpage.feature_4"),
        this.$t("subscriptionpage.feature_5"),
      ];
    },
    isLoggedIn() {
      return this.$store.getters["user/loggedIn"];
    },
  },
  mounted() {
    this.getSubscriptions();
  },
  methods: {
    openPaymentModal(id) {
      if (!this.isLoggedIn) {
        this.$router.push({ name: "Login" });
        return;
      }
      this.subscription = id;
      this.openModal = true;
    },
    closePaymentModal() {
      this.openModal = false;
    },
    getSubscriptions() {
      axios
        .get(`/subscriptions`)
        .then((response) => {
          this.subscriptions = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>